import React from "react";
import ReactDOM from 'react-dom/client';

import "./assets/style/style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style/base.css";
import "./assets/style/responsive.css";
import "./assets/style/left.css";

import "./assets/style/zeynep.css";
import "./assets/style/bootstrap-tagsinput.css";
import "./assets/style/bootstrap-tagsinput.less";
// import "./assets/style/semantic.min.css";
import "./assets/style/step-wizard.css";
import "./assets/style/developer.css";
import "./index.scss";
import "./index.css";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import configureStore from "./redux/store";


const store = configureStore();


const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);


reportWebVitals();
